/**
 * @generated SignedSource<<a496cb08d4af1bdba0a3614ab4eea348>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateCouponInput = {
  active?: boolean | null | undefined;
  assignmentOnly?: boolean | null | undefined;
  code?: string | null | undefined;
  discount?: number | null | undefined;
  discountType?: string | null | undefined;
  duration?: number | null | undefined;
  name?: string | null | undefined;
  uses?: number | null | undefined;
  validDays?: number | null | undefined;
  validFrom?: any | null | undefined;
  validTimeEnd?: number | null | undefined;
  validTimeStart?: number | null | undefined;
  validUntil?: any | null | undefined;
};
export type useCouponMutationsUpdateMutation$variables = {
  applicableToSystem?: string | null | undefined;
  id: string;
  input?: UpdateCouponInput | null | undefined;
};
export type useCouponMutationsUpdateMutation$data = {
  readonly updateCoupon: {
    readonly errors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly fields: ReadonlyArray<string> | null | undefined;
      readonly message: string | null | undefined;
      readonly shortMessage: string | null | undefined;
      readonly vars: any | null | undefined;
    }>;
    readonly result: {
      readonly active: boolean | null | undefined;
      readonly assignmentOnly: boolean;
      readonly code: string | null | undefined;
      readonly created: any | null | undefined;
      readonly discount: number | null | undefined;
      readonly discountType: string | null | undefined;
      readonly duration: number | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly oldId: string | null | undefined;
      readonly organizationId: string | null | undefined;
      readonly systemId: string | null | undefined;
      readonly systemOldId: string | null | undefined;
      readonly uses: number | null | undefined;
      readonly validDays: number | null | undefined;
      readonly validFrom: any | null | undefined;
      readonly validTimeEnd: number | null | undefined;
      readonly validTimeStart: number | null | undefined;
      readonly validUntil: any | null | undefined;
    } | null | undefined;
  };
};
export type useCouponMutationsUpdateMutation = {
  response: useCouponMutationsUpdateMutation$data;
  variables: useCouponMutationsUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicableToSystem"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "applicableToSystem",
        "variableName": "applicableToSystem"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCouponResult",
    "kind": "LinkedField",
    "name": "updateCoupon",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Coupon",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uses",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "systemId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "systemOldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignmentOnly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validDays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validTimeStart",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validTimeEnd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validFrom",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validUntil",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fields",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vars",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useCouponMutationsUpdateMutation",
    "selections": (v4/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useCouponMutationsUpdateMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "7d0db88a340bb8cf12cf357e35151279",
    "id": null,
    "metadata": {},
    "name": "useCouponMutationsUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation useCouponMutationsUpdateMutation(\n  $id: ID!\n  $input: UpdateCouponInput\n  $applicableToSystem: String\n) {\n  updateCoupon(id: $id, input: $input, applicableToSystem: $applicableToSystem) {\n    result {\n      id\n      oldId\n      name\n      code\n      active\n      discount\n      discountType\n      duration\n      uses\n      systemId\n      systemOldId\n      organizationId\n      assignmentOnly\n      validDays\n      validTimeStart\n      validTimeEnd\n      validFrom\n      validUntil\n      created\n    }\n    errors {\n      message\n      fields\n      code\n      shortMessage\n      vars\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "af81a8adfefce7a37b98e3ca9892f5ec";

export default node;
